import { useMemo } from "react"
import useIsDebug from "../hooks/useIsDebug"

export default function useAnimationDebug(forceDebug) {
	const queryDebug = useIsDebug()
	return useMemo(() => forceDebug || queryDebug, [forceDebug, queryDebug])
}
